import * as t from '../types';
import {GetGroupParticipants, GetGroupSession, GetTutorGroupSessions} from '../../services'


export const getGroupSession = () => async (dispatch) => {

    dispatch({
        type: t.GET_GROUP_SESSION_REQUEST
    });

    return await GetGroupSession()

        .then((data) => {
            dispatch({
                type: t.GET_GROUP_SESSION_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            dispatch({
                type: t.GET_GROUP_SESSION_FAILED,
                payload: err.response
            });
        });
};
